import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_HOST;

async function getDepartments(page?: number, limit?: number ) {
  const { data } = await axios.get(`${API_HOST}/v1/department`, {
    params: { limit, page },
  });
  return data;
}

async function creteDepartment(value: any) {
  const response = await axios.post(`${API_HOST}/v1/department`, value);
  return response;
}

async function updateDepartment(id: string, value: any) {
  const response = await axios.patch(`${API_HOST}/v1/department/${id}`, value);
  return response;
}

async function updateDepartmentPeople(id: string, people: string[]) {
  const response = await axios.patch(`${API_HOST}/v1/department/${id}/people`, {
    people,
  });
  return response;
}

async function updateDepartmentPermissions(id: string, permissions: string[]) {
  const response = await axios.patch(
    `${API_HOST}/v1/department/${id}/permissions`,
    {
      permissions,
    },
  );
  return response;
}

async function deleteDepartment(id: string) {
  const response = await axios.delete(`${API_HOST}/v1/department/${id}`);
  return response;
}

const departmentsManagement = {
  getDepartments,
  creteDepartment,
  updateDepartment,
  updateDepartmentPeople,
  updateDepartmentPermissions,
  deleteDepartment,
};

export default departmentsManagement;
